import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="image-blur"
export default class extends Controller {
  static targets = ["overlay"]

  connect() {
    // Controller is connected and ready
    // The blur effect and overlay are handled via CSS
  }

  showOverlay() {
    // Optional: could add analytics tracking here
  }

  hideOverlay() {
    // Optional: could add analytics tracking here
  }
}
